import React, {useState} from "react";
import ExportToExcelButton from "../ExportToExcelButton/ExportToExcelButton";
import {DAYS, MONTHS, WEEKS} from "../../../Constants/constants";

export default function TimeScaleFilter(props) {
    const [selected, setSelected] = useState(props.defaultScale != null ? props.defaultScale : MONTHS);

    const isSelected = (type) => {
        return `time-scale-filter-link ${selected === type ? 'time-scale-filter-link-selected' : ''}`
    }

    const filterData = (type) => {
        setSelected(type);
        if (props.setScale) props.setScale(type);
        // TODO: Alter Data according to the selected Time Scale
    }

    return (<div className={props.className || 'TimeScaleFilter'}>
        <p className={isSelected(DAYS)} onClick={() => {
            filterData(DAYS)
            props.setOffSet(0)
        }}>Daily</p> |
        <p className={isSelected(WEEKS)} onClick={() => {
            filterData(WEEKS)
            props.setOffSet(0)
        }}>Weekly</p> |
        <p className={isSelected(MONTHS)} onClick={() => {
            filterData(MONTHS)
            props.setOffSet(0)
        }}>Monthly</p>
        <div className={'ExportToExcelButton'}>
            {props.hasExportCsv && <ExportToExcelButton csvData={props.csvData || null} title={props.title || null}/>}
        </div>
    </div>)
}